import { useState } from "react"
import { colors, fonts, glyphs, icons, useMediaQuery } from "../../Styles"

interface ReportShortCut_Props {
  header: string
  amount: number
  onClick?: () => void
}
/**
 * ReportShortCut
 * @param header String to show.
 * @param amount Number to show.
 * @param onClick Function to handle onClick.
 * @returns A clickable component that shows an amount and header.
 */
export default function ReportShortCutCopy({header, amount, onClick}:ReportShortCut_Props) {
  const [isHovered, setIsHovered] = useState<boolean>(false)
  const tablet = useMediaQuery(`(min-width: 601px) and (max-width: 1021px)`);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}  
      onClick={onClick}
      style={{ 
        cursor: isHovered? "pointer" : "default", 
        opacity: isHovered? "0.3" : "1", 
        transition: "0.3s ease", 
        backgroundColor: colors.greyLightTertiary, 
        border: "5px solid"+colors.blueLightPrimary, 
        borderRadius: "10px", 
        height: "50px", 
        width: "100%", 
        display: "grid",
        gridTemplateColumns: "45px 1fr 45px",
        gridAutoRows: "1fr",
        boxSizing: "border-box",
        gap: "10px"
      }}
    >  

      <div style={{gridArea: "1/1/2/2", display: "flex", alignItems: "center", justifyContent: "center", borderRight: "2px solid"+colors.greyLightSecondary, margin: "8px 0px"}}>
        <p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyDarkPrimary}}>{amount}</p>
      </div>

      <div style={{gridArea: "1/2/2/3", display: "flex", alignItems: "center", justifyContent: "start" }}>
        <p style={{...fonts.paragraph, ...fonts.fontSize4, color: colors.greyDarkPrimary}}>{header}</p>
      </div>

      <div style={{gridArea: "1/3/2/4", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: colors.blueLightPrimary, paddingLeft: "5px"}}>
        <glyphs.Arrow size="25px"/>
      </div>

    </div>
  )
}